export default "__VITE_ASSET__TnXCk4Lo__"